import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create Tax Regime
export const createTdsTaxRegime = createAsyncThunk(
  'tdsTaxRegime/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/tds-tax-regime', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create TDS tax regime');
    }
  }
);
// Fetch All Tax Regimes
export const fetchTdsTaxRegimes = createAsyncThunk(
  'tdsTaxRegime/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/tds-tax-regime');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch TDS tax regimes');
    }
  }
);

// Fetch Tax Regime by ID
export const fetchTdsTaxRegimeById = createAsyncThunk(
  'tdsTaxRegime/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/tds-tax-regime/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch TDS tax regime');
    }
  }
);

// Update Tax Regime
export const updateTdsTaxRegime = createAsyncThunk(
  'tdsTaxRegime/update',
  async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/tds-tax-regime/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update TDS tax regime');
    }
  }
);

// Delete Tax Regime
export const deleteTdsTaxRegime = createAsyncThunk(
  'tdsTaxRegime/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/tds-tax-regime/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete TDS tax regime');
    }
  }
);
